module.exports = __webpack_public_path__ + "static/media/truck.819ffc91.png";